export const APP_PAGE_ROUTE = '/app/:appId/pages/:nodeId';
export const APP_API_ROUTE = '/app/:appId/apis/:nodeId';
export const APP_CODE_COMPONENT_ROUTE = '/app/:appId/codeComponents/:nodeId';
export const APP_CONNECTION_ROUTE = '/app/:appId/connections/:nodeId';
